export default __webpack_public_path__ + "static/media/stil_sword.d34bc311.bmp";